<template>
  <div>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      :selection="false"
      label-width="100px"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: '/alarm/firmware/page',
      columns: [
        {
          label: '版本号',
          prop: 'version'
        }, {
          label: '充电桩类型',
          prop: 'zhuangType',
          template: (index, reocrd) => {
            return reocrd.zhuangType == '1' ? '直流' : '交流'
          }
        }, {
          label: 'FTP服务器地址',
          prop: 'ftpPath'
        }, {
          label: 'FTP服务器端口号',
          prop: 'ftpPort'
        }, {
          label: '下载超时时间',
          prop: 'downTimeOut'
        }, {
          label: '修改时间',
          prop: 'updateDate'
        }
      ],
      handles: {
        width: 200,
        btns: [
          {
            label: '修改',
            permission: 'system.electric.pile.type.management.update',
            handle: (resp) => {
              this.$router.push({
                path: 'versionModify',
                query: { id: resp.id }
              })
            }
          }
          // {
          //   label: '删除',
          //   permission: 'system.electric.pile.type.management.delete',
          //   style: 'color:red',
          //   url: '/alarm/firmware/delete',
          //   method: 'post',
          //   isConfirm: true,
          //   before: (index, record) => {
          //     return [record.id]
          //     // arr.push(record.id)
          //   },
          //   handle: () => {
          //     this.$refs.tableref.queryTable()
          //   }
          // }
        ]
      },
      query: [
        {
          label: '版本号',
          prop: 'version',
          placeholder: '请输入版本号'
        }, {
          label: '充电桩类型',
          prop: 'zhuangType',
          placeholder: '请选择充电桩类型',
          type: 'select',
          data: [{
            label: '交流',
            value: '2'
          }, {
            label: '直流',
            value: '1'
          }]
        },
        {
          label: '修改时间',
          prop: 'updateTime',
          placeholder: '',
          type: 'date2'
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'system.electric.pile.type.management.add',
          type: 'primary',
          before: (index, record) => {
            this.$router.push({
              path: 'versionAdd'
            })
          }
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/views/systemManagement/firmwareVersion.vue